var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:[_vm.link.active === 'true' ? 'active' : ''],attrs:{"href":_vm.link.url,"aria-label":("navigate to " + (_vm.link.title) + " page")}},[_vm._v(_vm._s(_vm.link.title))])}
var staticRenderFns = []

export { render, staticRenderFns }